import React from "react";

import Grid from '@mui/joy/Grid';
import {CardOverflow, Stack, TabList, TabPanel, Tabs} from "@mui/joy";
import Tab, {tabClasses} from '@mui/joy/Tab';
import ListItemDecorator from "@mui/joy/ListItemDecorator";
import Card from "@mui/joy/Card";
import CardContent from "@mui/joy/CardContent";
import Typography from "@mui/joy/Typography";
import Box from "@mui/joy/Box";

// components
import UserSubscriberContext from "../../context/UserSubscriberContext";
import CommentSidebar from "../Comment/CommentSidebar";
import retrievePermission from "../../utils/retrievePermission";
import BaseApi from "../../utils/BaseApi";
import AgentRunEntityCreate from "../AI/AgentRunEntityCreate";


class CommonDetail extends React.Component {
    static contextType = UserSubscriberContext

    constructor(props) {
        super(props);
        this.state = {
            agentPermission: 0,
            agents: [],
        };
    }

    async componentDidMount() {
        await this.retrieveAgentRunPermission();
    }

    async retrieveAgentRunPermission() {
        let agentPermission = await retrievePermission(
            'AgentViewSet',
            'list',
            this.context.subscriberObject
        );
        agentPermission *= await retrievePermission(
            'AgentRunViewSet',
            'create',
            this.context.subscriberObject
        );
        this.setState(
            {
                agentPermission: agentPermission,
            },
            () => {
                this.retrieveAgents()
            }
        );
    }

    async retrieveAgents(){
        if (this.state.agentPermission){
            let url = `agent/`;
                const api = new BaseApi();
                const params = {
                    entities: JSON.stringify(
                        [this.props.appName, ]
                    ),
                };
                let response = await api.get(url, params);
                let agents = response.data.results
                this.setState({
                    agents: agents
                })
        }
    }

    render() {
        return (
            <Grid
                container
                spacing={3}
                sx={{height: '100%'}}
            >
                <Grid
                    md={7}
                    xs={12}
                >
                    <Stack
                        spacing={1}
                        variant="plain"
                        color="neutral"
                        sx={(theme) => ({
                            display: 'flex',
                            flexDirection: 'column',
                            borderRadius: 'md',
                            width: '100%',
                            justifyContent: "space-between",
                            alignItems: 'stretch',
                            alignContent: 'space-between',
                            [theme.breakpoints.up("md")]: {height: '95vh'},
                        })}
                    >
                        <Card
                            variant="soft"
                            sx={{
                                display: 'flex',
                                width: '100%',
                            }}
                            orientation="horizontal"
                            size={'sm'}
                        >
                            {
                                this.props.header.leftOverflow?
                                    <CardOverflow
                                        variant='soft'
                                        color={this.props.header.leftOverflow.color}
                                        sx={{
                                            px: 0.2,
                                            borderLeft: '1px solid',
                                            borderColor: 'divider',
                                        }}
                                    >
                                        <Stack
                                            spacing={1}
                                        >
                                            {
                                                this.props.header.leftOverflow.icon?
                                                    this.props.header.leftOverflow.icon:null
                                            }
                                            <Typography
                                                sx={{
                                                    writingMode: 'vertical-rl',
                                                    transform: 'rotate(180deg)',
                                                    fontSize: 'xs',
                                                    fontWeight: 'xl',
                                                    letterSpacing: '1px',
                                                    textTransform: 'uppercase',
                                                }}
                                            >

                                                {this.props.header.leftOverflow.title}
                                            </Typography>
                                            <Box>
                                                {
                                                    this.props.header.leftOverflow.component?
                                                        this.props.header.leftOverflow.component:null
                                                }
                                            </Box>
                                        </Stack>
                                    </CardOverflow>:
                                    null
                            }
                            <CardContent>
                                <this.props.header.component
                                    {...this.props.header.componentProps}
                                />
                            </CardContent>
                            {
                                this.props.header.rightOverflow?
                                    <CardOverflow
                                        variant='soft'
                                        color={this.props.header.rightOverflow.color}
                                        sx={{
                                            px: 0.2,
                                            borderLeft: '1px solid',
                                            borderColor: 'divider',
                                            flexDirection: 'column',
                                        }}
                                    >
                                        <Stack
                                            spacing={1}
                                        >
                                            {
                                                this.props.header.rightOverflow.icon?
                                                    this.props.header.rightOverflow.icon:null
                                            }
                                            <Typography
                                                sx={{
                                                    writingMode: 'vertical-rl',
                                                    transform: 'rotate(180deg)',
                                                    fontSize: 'xs',
                                                    fontWeight: 'xl',
                                                    letterSpacing: '1px',
                                                    textTransform: 'uppercase',
                                                }}
                                            >

                                                {this.props.header.rightOverflow.title}
                                            </Typography>
                                            <Box>
                                                {
                                                    this.props.header.rightOverflow.component?
                                                        this.props.header.rightOverflow.component:null
                                                }
                                            </Box>
                                        </Stack>
                                    </CardOverflow>:
                                    null
                            }
                        </Card>
                        {this.props.extraComponents?.filter((each) => !each.hidden).map((c) => (
                            <Card
                                variant="soft"
                                sx={{
                                    display: 'flex',
                                    width: '100%',
                                }}
                                orientation="horizontal"
                                color={c.color}
                                size={'sm'}
                            >
                                <CardContent>
                                    <c.component {...c.props}/>
                                </CardContent>
                            </Card>
                        ))}
                        <Tabs
                            orientation={'horizontal'}
                            aria-label='Placement indicator tabs'
                            defaultValue={this.props.defaultTabValue}
                            size={'sm'}
                            sx={(theme) => ({
                                gridColumn: '1/-1',
                                borderRadius: 'var(--joy-radius-md);',
                                mt: 1,
                                flexGrow: 4,
                                flexDirection: 'column',
                                height: 'auto',
                                width: '100%',
                                justifyContent: "flex-start",
                                alignItems: 'stretch',
                                alignContent: 'space-between',
                                overflow: 'hidden',
                                [theme.breakpoints.up("md")]: {overflow: 'hidden',}
                            })}
                        >
                            <TabList
                                disableUnderline
                                sx={{
                                    pr: 1,
                                    pl: 1,
                                    pt: 1,
                                    pb: 2,
                                    gap: 0.5,
                                    borderRadius: 'md',
                                    bgcolor: 'background.level1',
                                    [`& .${tabClasses.root}[aria-selected="true"]`]: {
                                        bgcolor: 'primary.softBg',
                                    },
                                    display: 'block',
                                }}
                            >
                                {this.props.tabComponents.filter((each) => !each.hidden).map(
                                    each => {
                                        return (
                                            <Tab
                                                disableIndicator
                                                value={each.value}
                                                sx={{
                                                    borderRadius: 'md',
                                                    flex: 'none',
                                                    display: 'inline-block',
                                                    scrollSnapAlign: 'start',
                                                    verticalAlign: 'middle',
                                                    pl: 0.5,
                                                    pr: 0.5,
                                                }}
                                            >
                                                <Stack
                                                    direction={'row'}
                                                    spacing={0.1}
                                                    alignItems={'center'}
                                                >
                                                    <ListItemDecorator
                                                        sx={{
                                                            verticalAlign: 'middle',
                                                        }}
                                                    >
                                                        <each.icon fontSize={'small'}/>
                                                    </ListItemDecorator>
                                                    <Typography
                                                        level={'body-sm'}
                                                        sx={{
                                                            display: 'inline',
                                                            verticalAlign: 'middle',
                                                        }}
                                                    >
                                                        {each.title}
                                                    </Typography>
                                                </Stack>
                                            </Tab>
                                        )
                                    }
                                )}
                            </TabList>
                            <Stack
                                sx={{
                                    flexGrow: 4,
                                    height: '80%',
                                }}
                            >
                                {this.props.tabComponents.filter((each) => !each.hidden).map(
                                    each => {
                                        return (
                                                <TabPanel
                                                    size={'sm'}
                                                    value={each.value}
                                                    variant={'soft'}
                                                    sx={{
                                                        mt: 1,
                                                        borderRadius: 'md',
                                                        width: '100%',
                                                        height: '100%',
                                                        overflowY: 'scroll',
                                                    }}
                                                >
                                                    {each.component}
                                                </TabPanel>
                                        )
                                    }
                                )}
                            </Stack>
                        </Tabs>
                    </Stack>
                </Grid>
                <Grid
                    md={5}
                    xs={12}
                    sx={{
                        height: '100%',
                    }}

                >
                    {
                        this.state.agentPermission && this.state.agents.length?
                            <Card
                                color={'grey'}
                                variant={'soft'}
                                size={'sm'}
                                sx={{
                                    mb: 1,
                                    p: 1
                                }}
                            >
                                <Stack
                                    direction={'row'}
                                    spacing={0.5}
                                    sx={{
                                        width: '100%',
                                        overflowX: 'scroll',
                                        minHeight: '38px',
                                        maxHeight: '38px',
                                    }}
                                >
                                    {
                                        this.state.agents.map(agent => (
                                            <AgentRunEntityCreate
                                                agent={agent}
                                                entity={this.props.appName}
                                                entityId={this.props.appId}
                                            />
                                        ))
                                    }
                                </Stack>
                            </Card>:
                            null
                    }
                    <CommentSidebar
                        height={this.state.agentPermission && this.state.agents.length?'95%':null}
                        appName={this.props.appName}
                        appId={this.props.appId}
                    />
                </Grid>
            </Grid>
        )
    }
}

export default CommonDetail;
